import React from 'react';
import './TextInput.css';

/**
 * TextInput Component
 * Standardized text input field
 * 
 * @param {string} label - Input label
 * @param {string} placeholder - Placeholder text
 * @param {string} value - Input value
 * @param {function} onChange - Change handler: (value: string) => void
 * @param {string} error - Error message
 * @param {boolean} disabled - Disabled state
 * @param {boolean} required - Required field indicator
 * @param {string} type - Input type (default: 'text')
 * @param {string} helperText - Helper text below input
 * @param {string} className - Additional CSS classes
 */
const TextInput = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  type = 'text',
  helperText,
  className = ''
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const inputId = `text-input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`text-input-container ${error ? 'error' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="text-input-label">
          {label}
          {required && <span className="text-input-required">*</span>}
        </label>
      )}
      <input
        type={type}
        id={inputId}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        className={`text-input ${error ? 'error' : ''}`.trim()}
        aria-required={required}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
      />
      {(error || helperText) && (
        <div className="text-input-footer">
          {error && (
            <span id={`${inputId}-error`} className="text-input-error" role="alert">
              {error}
            </span>
          )}
          {!error && helperText && (
            <span id={`${inputId}-helper`} className="text-input-helper">
              {helperText}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TextInput;

